const GEN_SLIDER_JS_URI = '../assets/js/slider.js';

const themePath = landing.dist_path;

window.collections = {};

const SCRIPTS = [
    {
        'url' : GEN_SLIDER_JS_URI,
        'sel' : '.carrousel-container',
        'col' : 'Slider' 
    }
];

let selectors = [];
for(let script of SCRIPTS ) {
    selectors.push(script.sel);
}
const obj_present = Array.from(document.querySelectorAll( selectors.join(',') ) );

for(let script of SCRIPTS ) {
    if(Array.from) {
        collections[script.col] = Array.from(document.querySelectorAll(script.sel));
        if(collections[script.col].length > 0) {
            if(script.lazy) {
                let encours = false,
                    observer = new IntersectionObserver(function(entries) {
                    for (let j = 0, lg = entries.length; j < lg; j++) {
                        if (entries[j].intersectionRatio <= 0 || encours) return;
                        encours = true;
                        new loadExt([themePath+script.url]);
                        for (let k = 0, lgt = entries.length; k < lgt; k++) {
                            observer.unobserve(entries[k].target);
                        }
                    }
                }, obsOptions);

                for (let i = 0, l = collections[script.col].length; i < l; i++) {
                    observer.observe(collections[script.col][i]);
                }

            } else {
                new loadExt([themePath+script.url]);
            }
        }
    }
}


function loadExt(files, after) {
    this.files = files;
    this.js = [];
    this.head = document.getElementsByTagName("head")[0];
    this.after = after || function () {
    };
    this.loadStyle = (file) => {
        let link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = file;
        this.head.appendChild(link);
    };
    this.loadScript = (i) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.js[i];
        const loadNextScript = () => {
            if (++i < this.js.length) this.loadScript(i);
            else this.after();
        };
        script.onload = () => {
            loadNextScript();
        };
        this.head.appendChild(script);
    };
    for (let i = 0; i < this.files.length; i++) {
        if (/\.js$|\.js\?/.test(this.files[i])) this.js.push(this.files[i]);
        if (/\.css$|\.css\?/.test(this.files[i])) this.loadStyle(this.files[i]);
    }
    if (this.js.length > 0) this.loadScript(0);
    else this.after();
}